export enum SwitchPage {
  TenantPage = "tenantPage",
  LandlordPage = "landlordPage",
  BillingPage = "billingPage",
  TcfPage = "tcfPage",
  PropertyPage = "propertyPage",
  EnergyPage = "energyPage",
}
